import axios from "../../utility/customAxios";
import {Permission} from "./rbac";

export interface Featureflags {
    booleanFlags: Map<string, boolean>
}

export const getFeatureFlags = async (): Promise<Featureflags> => {
    const response = await axios.get(`/api/v1/frontend/features/flags`);
    const data = response.data as Featureflags;
    if (!data) {
        throw new Error('Failed to load feature flags');
    }
    data.booleanFlags = new Map<string, boolean>(Object.entries(data.booleanFlags));
    return data;
};